import React from 'react';
import { Card } from 'react-bootstrap';

import excelIcon from '../../../assets/excel-logo.png';
import downloadIcon from '../../../assets/download.svg';

interface Props {
  filename: string;
  download: () => void;
}

const ExcelFileCard = ({ filename, download }: Props) => (
  <Card style={{ width: '160px' }}>
    <Card.Body style={{ padding: '35px 20px' }}>
      <Card.Img src={excelIcon} height="78px" width="118px" />
    </Card.Body>
    <Card.Footer className="d-flex align-items-center justify-content-between">
      <span className="mb-0">{filename}</span>

      <img
        className="icon"
        src={downloadIcon}
        height="24px"
        alt="download"
        role="presentation"
        onClick={download}
      />
    </Card.Footer>
  </Card>
);

export default ExcelFileCard;
